<template>
    <div class="talent-level-container">
        <div class="list-wrap">
            <div class="block width-1">
                <router-link class="button is-success" :to="{name:'addCartPrizeEdit'}">新增</router-link>
            </div>
            <div class="clearfix" v-if="count>0">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <table class="table is-bordered">
                        <thead>
                        <tr>
                            <th>游戏ID</th>
                            <th>标题</th>
                            <th>开始时间</th>
                            <th>结束时间</th>
                            <th>操作</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in tableData" :key="index">
                            <td>{{item.activityId}}</td>
                            <td>{{item.title}}</td>
                            <td>{{item.startTime}}</td>
                            <td>{{item.endTime}}</td>
                            <td>
                                <router-link class="button is-info" :to="{name:'addCartPrizeConfig',query:{activityId:item.activityId}}">奖品配置</router-link>
                                <router-link class="button is-info" :to="{name:'addCartRuleConfig',query:{activityId:item.activityId}}">规则配置</router-link>
                                <router-link class="button is-info" :to="{name:'addCartPrizeRecord',query:{activityId:item.activityId}}">中奖记录</router-link>
                                <router-link class="button is-info" :to="{name:'addCartPrizeEdit',query:{activityId:item.activityId}}">编辑</router-link>
                                <button class="button is-danger"  @click="removeActivity(item,index)">删除</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </article>
            </div>
            <div class="clearfix" v-if="count>0">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    import { formatDate } from 'UTILS/date';
    export default{
        data(){
            return{
                count: 0,
                pageSize: 20,
                page: 1,
                tableData:[]
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.getActivityList();
            })
        },
        methods:{
            /*
            * 点击删除触发
            * */
            removeActivity(item,index){
                if (confirm('是否确定删除?')) {
                    HttpRequest.get("/admin.php?method=cartactivity.removeActivity",{activityId:item.activityId},true).then((response)=>{
                        if(response.data.success == 1){
                            this.$message("删除成功!");
                            this.tableData.splice(index,1);
                            this.count--;
                        }
                    })
                }
            },
            handleCurrentChange(value) {
                if(this.page !== value){
                    this.page = value;
                    this.getActivityList();
                }
            },
            getActivityList() {
                HttpRequest.get('/admin.php?method=cartactivity.showActivity', {page:this.page,pageSize:this.pageSize},true).then((response) => {
                    this.tableData = response.data.list;
                    _.each(response.data.list,(item,index)=>{
                        item.startTime = formatDate(item.startTime,'yyyy-MM-dd hh:mm:ss');
                        item.endTime = formatDate(item.endTime,'yyyy-MM-dd hh:mm:ss');
                    })
                    this.count = parseInt(response.data.count);
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .list-box{
        margin-bottom: 20px;
    }
    .remark-col{
        width: 300px;
    }
    .marginRight{
        margin-right: 5px;
        margin-bottom: 5px;
    }
</style>
